import React, { useState } from "react";
import { useRekapAbsensi } from "./useRekapAbsensi";
import {
  monthNames,
  buildPayrollRow,
  hitungTakeHomePay,
} from "../../../util/rekapAbsensiUtils";
import { exportPayrollExcel } from "../../../util/payrollExcel";
import DetailAbsensiTable from "../../../component/DetailAbsensiTable/DetailAbsensiTable";
import RincianPerhitunganPayroll from "../../../component/RincianPerhitunganPayroll/RincianPerhitunganPayroll";
import PopUpComponent from "../../../component/PopUpComponent/PopUpComponent";
import CloseIcon from "../../../asset/close_icon.png";
import { hasRole } from "../../../util/function";
import "./RekapAbsensi.css";

const blankIfZero = (v) => {
  const n = Number(v);
  return !v || Number.isNaN(n) || n === 0 ? "" : v;
};

const RekapAbsensiRow = ({
  data,
  index,
  startDate,
  endDate,
  typeKaryawan,
  onChanged,
}) => {
  const [expanded, setExpanded] = useState(false);

  const row = buildPayrollRow(data, startDate, endDate, typeKaryawan);

  return (
    <>
      <tr
        className={`rekap-row${expanded ? " expanded" : ""}`}
        onClick={() => setExpanded(!expanded)}
      >
        <td>{index + 1}</td>
        <td>
          <span className={`rekap-expand-arrow${expanded ? " expanded" : ""}`}>
            ▶
          </span>
          {data.name}
        </td>
        <td>{data.bagian}</td>
        <td>{blankIfZero(row.jamHalf)}</td>
        <td>{blankIfZero(row.totalHariKerja)}</td>
        <td className="rekap-cell-probation">
          {blankIfZero(row.jamHalfProbation ?? row.hariHalfProbation)}
        </td>
        <td className="rekap-cell-probation">
          {blankIfZero(row.totalHariKerjaProbation)}
        </td>
      </tr>

      {expanded && (
        <tr>
          <td colSpan="8" className="rekap-expand-td">
            <div className="rekap-detail-panel">
              <div className="rekap-detail-panel-header">
                Rincian Perhitungan — {data.userId} {data.name}
              </div>

              <div className="rekap-detail-panel-body">
                <div className="rekap-detail-col-rincian">
                  <RincianPerhitunganPayroll
                    row={row}
                    typeKaryawan={typeKaryawan}
                    periodeStart={startDate}
                    bagian={data.bagian}
                    keteranganKurangBayar={data.keteranganKurangBayar}
                    keteranganLebihBayar={data.keteranganLebihBayar}
                  />
                </div>

                <div className="rekap-detail-col-kanan">
                  <DetailAbsensiTable
                    detail={data.detail}
                    userId={data.userId}
                    onChanged={onChanged}
                  />
                </div>
              </div>
            </div>
          </td>
        </tr>
      )}
    </>
  );
};

const RekapAbsensi = () => {
  const {
    getTim,
    dataRekap,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    valueSearch,
    setValueSearch,
    loading,
    errorMessage,
    resetDate,
    setResetDate,
    popUpResetDate,
    setPopUpResetDate,
    typeKaryawan,
    setTypeKaryawan,
    resetLoading,
    handleResetPayroll,
    refetch,
  } = useRekapAbsensi();

  console.log(dataRekap);

  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });

  const handleSort = (key) => {
    setSortConfig((prev) =>
      prev.key === key
        ? { key, direction: prev.direction === "asc" ? "desc" : "asc" }
        : { key, direction: "asc" }
    );
  };

  const sortIndicator = (key) =>
    sortConfig.key === key
      ? sortConfig.direction === "asc"
        ? " ▲"
        : " ▼"
      : "";

  const handleExportRekapAbsensi = () => {
    const rows = dataRekap
      .map((data) => ({
        ...buildPayrollRow(data, startDate, endDate, typeKaryawan),
        // pastikan window probation ikut di row (dipakai isEligibleForExport)
        probationStart: data.probationStart ?? null,
        probationUntil: data.probationUntil ?? null,
      }))
      .filter((row) => row.takeHomePay > 0);

    const d = new Date();
    const labelTipe = typeKaryawan === "contract" ? "Kontrak" : "Permanen";
    exportPayrollExcel(
      rows,
      `Rekap Absensi ${labelTipe} ${
        monthNames[d.getMonth()]
      } ${d.getFullYear()}.xlsx`,
      endDate
    );
  };

  const filteredData = dataRekap.filter((data) => {
    const takeHomePay = hitungTakeHomePay(
      data,
      startDate,
      endDate,
      typeKaryawan
    );
    return takeHomePay !== 0;
  });

  const getSortValue = (data, key) => {
    if (key === "name" || key === "bagian") return String(data[key] || "");
    const row = buildPayrollRow(data, startDate, endDate, typeKaryawan);
    return Number(row[key]) || 0;
  };

  const displayedData = sortConfig.key
    ? [...filteredData].sort((a, b) => {
        const va = getSortValue(a, sortConfig.key);
        const vb = getSortValue(b, sortConfig.key);
        const result =
          typeof va === "string"
            ? va.localeCompare(vb, "id", { sensitivity: "base" })
            : va - vb;
        return sortConfig.direction === "asc" ? result : -result;
      })
    : filteredData;

  return (
    <div className="container-rekap-absensi">
      {popUpResetDate ? (
        <PopUpComponent>
          <div className="rekap-popup-header-row">
            <p className="rekap-popup-title">
              Apakah Kamu yakin ingin me-reset karyawan {typeKaryawan}
            </p>
            <img
              src={CloseIcon}
              onClick={() => setPopUpResetDate(false)}
              className="rekap-popup-close-icon"
              alt="Tutup"
            />
          </div>
          <div className="rekap-popup-reset-row">
            <div>
              <p>Tanggal Reset</p>
              <input
                type="date"
                className="rekap-popup-date-input"
                value={resetDate}
                onChange={(e) => setResetDate(e.target.value)}
              />
            </div>
            <button
              className={`rekap-btn-kirim${resetLoading ? " is-loading" : ""}`}
              disabled={resetLoading}
              onClick={handleResetPayroll}
            >
              {resetLoading ? "Memproses..." : "Kirim"}
            </button>
          </div>
        </PopUpComponent>
      ) : (
        ""
      )}
      <div className="wrapper-card-rekap-absensi">
        <div className="rekap-header-row">
          <div className="rekap-filter-group">
            <div className="rekap-filter-item">
              <p>Tanggal Awal</p>
              <input
                type="date"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
              />
            </div>
            <div className="rekap-filter-item">
              <p>Tanggal Akhir</p>
              <input
                type="date"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
              />
            </div>
            <div className="rekap-filter-item">
              <p>Karyawan</p>
              <select
                style={{ width: "100%" }}
                value={typeKaryawan}
                onChange={(e) => setTypeKaryawan(e.target.value)}
              >
                <option value={"contract"}>Kontrak</option>
                <option value={"permanent"}>Permanen</option>
              </select>
            </div>
          </div>

          {hasRole(getTim, "hrd_admin", "super_user") ? (
            <div className="rekap-action-buttons">
              <button
                className="rekap-btn rekap-btn-export"
                onClick={handleExportRekapAbsensi}
              >
                Export Excel
              </button>
              <button
                className="rekap-btn rekap-btn-reset"
                onClick={() => setPopUpResetDate(true)}
              >
                Reset
              </button>
            </div>
          ) : (
            ""
          )}
        </div>

        <input
          type="text"
          className="rekap-search-input"
          placeholder="Search"
          onChange={(e) => setValueSearch(e.target.value)}
        />

        {errorMessage ? (
          <p style={{ color: "red", marginLeft: "12px" }}>{errorMessage}</p>
        ) : (
          ""
        )}

        <div className="table-wrapper-rekap-absensi">
          <table className="table_dashboard mobile-font-size-10">
            <thead>
              <tr>
                <th>No.</th>
                <th
                  className="rekap-th-sortable"
                  onClick={() => handleSort("name")}
                >
                  Nama{sortIndicator("name")}
                </th>
                <th
                  className="rekap-th-sortable"
                  onClick={() => handleSort("bagian")}
                >
                  Bagian{sortIndicator("bagian")}
                </th>
                <th
                  className="rekap-th-sortable"
                  onClick={() => handleSort("jamHalf")}
                >
                  &#189; Hari (Jam){sortIndicator("jamHalf")}
                </th>
                <th
                  className="rekap-th-sortable"
                  onClick={() => handleSort("totalHariKerja")}
                >
                  Total Hari{sortIndicator("totalHariKerja")}
                </th>
                <th
                  className="rekap-th-sortable rekap-th-probation"
                  onClick={() => handleSort("jamHalfProbation")}
                >
                  &#189; Hari Probation (Jam){sortIndicator("jamHalfProbation")}
                </th>
                <th
                  className="rekap-th-sortable rekap-th-probation"
                  onClick={() => handleSort("totalHariKerjaProbation")}
                >
                  Hari Probation{sortIndicator("totalHariKerjaProbation")}
                </th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="8" style={{ textAlign: "center" }}>
                    Loading...
                  </td>
                </tr>
              ) : dataRekap.length === 0 ? (
                <tr>
                  <td colSpan="8" style={{ textAlign: "center" }}>
                    Tidak ada data
                  </td>
                </tr>
              ) : (
                displayedData.map((data, index) => (
                  <RekapAbsensiRow
                    key={data.userId}
                    data={data}
                    index={index}
                    startDate={startDate}
                    endDate={endDate}
                    typeKaryawan={typeKaryawan}
                    onChanged={refetch}
                  />
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default RekapAbsensi;
